import { Skeleton, styled, Typography } from "@mui/material";

import { formatDateToRecord, LocalTimeTooltip } from "modules/common";

import {
  ColorMap,
  TIMELINE_COLORS,
  TimeLineColor,
} from "../../constants/Timeline";

export interface TimelineRecordProps {
  color: TimeLineColor;
  colorMap: ColorMap;
  createdAt: string;
  status: string;
  "data-testid"?: string;
  highlight?: boolean;
}

export function TimelineRecord({
  status,
  createdAt,
  highlight,
  color,
  colorMap,
  "data-testid": dataTestId,
}: TimelineRecordProps) {
  const moment = new Date(createdAt);
  const time = formatDateToRecord(createdAt);

  const textColor = highlight ? colorMap.get(color) : TIMELINE_COLORS.default;

  return (
    <div>
      <StatusLabel
        color={textColor}
        data-testid={dataTestId}
        variant="tinyBold"
      >
        {status}
      </StatusLabel>
      <LocalTimeTooltip date={moment} sx={{ pb: 0.5, mb: -0.5 }}>
        <TimeLabel color={textColor} variant="tiny">
          {time}
        </TimeLabel>
      </LocalTimeTooltip>
    </div>
  );
}

export function TimelineRecordSkeleton() {
  return (
    <SkeletonWrapper>
      <Skeleton
        sx={{
          width: TIMELINE_RECORD_SKELETON_ITEM_1_WIDTH,
          height: TIMELINE_RECORD_SKELETON_ITEM_HEIGHT,
        }}
      />
      <Skeleton
        sx={{
          width: TIMELINE_RECORD_SKELETON_ITEM_2_WIDTH,
          height: TIMELINE_RECORD_SKELETON_ITEM_HEIGHT,
          mt: 1,
        }}
      />
    </SkeletonWrapper>
  );
}
const TIMELINE_RECORD_SKELETON_ITEM_1_WIDTH = 100;
const TIMELINE_RECORD_SKELETON_ITEM_2_WIDTH = 217;
const TIMELINE_RECORD_SKELETON_ITEM_HEIGHT = 14;

const StatusLabel = styled(Typography)(({ theme, color }) => ({
  display: "flex",
  letterSpacing: 1,

  ...(color === TIMELINE_COLORS.default && {
    color: theme.palette.text.high,
  }),
}));

const TimeLabel = styled(Typography)(({ theme, color }) => ({
  display: "inline",

  ...(color === TIMELINE_COLORS.default && {
    color: theme.palette.text.low,
  }),
}));

const SkeletonWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const TimelineRecordListSkeleton = styled("div")(({ theme }) => ({
  flexGrow: 1,
  flexDirection: "column",
  display: "flex",

  "& *:not(:first-child)": {
    marginTop: theme.spacing(2),
  },
}));
